import { render, staticRenderFns } from "./info-publish.vue?vue&type=template&id=26197251&scoped=true"
import script from "./info-publish.vue?vue&type=script&lang=js"
export * from "./info-publish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26197251",
  null
  
)

export default component.exports